<template>
	<div class='tw-gap-2 tw-flex tw--mx-3'>
		<div class="px-3 tw-w-2/5">
			<p-card>
				<div class="form-subsidiary">
					<h2
						class="tw-mb-2"
						:style="`color:${$appColors.info}`"
					>Agencias</h2>
					<form>
						<v-layout row>
							<v-flex xs12>
								<label for="new-subsidiarie-name"
									class="name-input"
									:style="`color:${$appColors.info}`">
									Nombre
									<input
										class="new-survey-input "
										placeholder="Nombre"
										v-model="newSubsidiary.name"/>
									<span
										class="form-group__message"
										v-if="!$v.newSubsidiary.name.required"
										:style="`color:${$appColors.error}`">
										El nombre es obligatorio
									</span>
								</label>
							</v-flex>
						</v-layout>
						<v-layout row>
							<v-flex xs12>
								<label for="new-subsidiarie-name"
									class="name-input"
									:style="`color:${$appColors.info}`">
									Dirección
									<input
										class="new-survey-input"
										placeholder="Dirección"
										v-model="newSubsidiary.address"/>
									<span
									class="form-group__message"
									v-if="!$v.newSubsidiary.address.required"
									:style="`color:${$appColors.error}`">
									La dirección es obligatoria
								</span>
								</label>
							</v-flex>
						</v-layout>
						<v-layout row>
							<v-flex xs6 tw-pr-1>
								<label for="new-subsidiarie-name"
									class="name-input"
									:style="`color:${$appColors.info}`">
									Código
									<input
										class="new-survey-input"
										placeholder="Código"
										v-model="newSubsidiary.code"/>
										<span
											class="form-group__message"
											v-if="!$v.newSubsidiary.code.required"
											:style="`color:${$appColors.error}`">
											El código es obligatorio
										</span>
								</label>
							</v-flex>
							<v-flex xs6 tw-pl-1>
								<label for="new-subsidiarie-name"
									class="name-input"
									:style="`color:${$appColors.info}`">
									Teléfono
									<input
										class="new-survey-input"
										placeholder="Teléfono"
										v-model="newSubsidiary.phone"/>
										<span
										class="form-group__message"
										v-if="!$v.newSubsidiary.phone.required"
										:style="`color:${$appColors.error}`">
										El teléfono es obligatorio
									</span>
								</label>
							</v-flex>
						</v-layout>
						<v-layout row>
							<v-flex xs9 tw-pr-1>
								<label for="new-subsidiarie-name"
									class="name-input"
									:style="`color:${$appColors.info}`">
									E-mail
									<input
										class="new-survey-input"
										placeholder="E-mail"
										v-model="newSubsidiary.email"/>
										<span
										class="form-group__message"
										v-if="!$v.newSubsidiary.email.required"
										:style="`color:${$appColors.error}`">
										El E-mail es obligatorio
									</span>
								</label>
							</v-flex>
							<v-flex xs3 tw-pl-1>
								<label for="new-subsidiarie-name"
									class="name-input"
									:style="`color:${$appColors.info}`">
									N. Empleados
									<input
										class="new-survey-input"
										placeholder="N. Empleados"
										v-model="newSubsidiary.numEmployees"/>
									<span
										class="form-group__message"
										v-if="!$v.newSubsidiary.numEmployees.required"
										:style="`color:${$appColors.error}`">
										El N. es obligatorio
									</span>
								</label>
							</v-flex>
						</v-layout>
						<v-layout row>
							<v-flex xs12>
								<label :style="`color:${$appColors.info}`"
									class="name-input">
									Puestos
									<v-select
										label="Puestos"
										class="select-core"
										hide-details
										multiple
										chips
										autocomplete
										clearable
										height="17"
										outline
										single-line
										:items="jobList"
										item-value="id"
										item-text="name"
										v-model="newSubsidiary.jobsSubsidiary"
										return-object
									>
										<template slot="selection" slot-scope="data">
											<v-chip
												class="tag-chip"
												close
												@input="removeItem(data.item)">
												{{ data.item.name }}
											</v-chip>
										</template>
									</v-select>
									<span
										class="form-group__message"
										v-if="!$v.newSubsidiary.jobsSubsidiary.required"
										:style="`color:${$appColors.error}`">
										Seleccione al menos un puesto
									</span>
								</label>
							</v-flex>
						</v-layout>
					</form>
				</div>
				<p-horizontal-divider />
				<div class="tw-text-center">
					<p-button
						type="black"
						@click="clearForm">Cancelar
					</p-button>
					<p-button
						type="primary"
						:disabled="!isFormValid"
						@click="saveSubsidiary">{{ textButton }}
					</p-button>
					
				</div>
			</p-card>
		</div>
		<div class="px-3 tw-w-3/5">
			<p-card>
				<app-table
					class="is-not-selectable no-main-list"
					:columns="columns"
					:filter-columns="false"
					:main-list="true"
					:rows="rows"
					:items-quantity="6"
					:items-total-quantity="totalItems"
					:current-page="currentPage"
					:last-page="lastPage"
					title="Agencias"
					btn-actions
					@on-page="changePage"
					@on-search-event="onSearchEvent"
					@changeSort="changeSort"
					@changeColor="changeColor">
					<template slot="rows" slot-scope="props">
						<td v-show="showRow(columns, 1)">{{ props.row.code }}</td>
						<td v-show="showRow(columns, 2)">{{ props.row.name }}</td>
						<td v-show="showRow(columns, 3)">{{ props.row.address }}</td>
						<td v-show="showRow(columns, 4)">{{ props.row.email }}</td>
						<td v-show="showRow(columns, 5)"  @click.stop="stopClick">
							<app-tooltip-button
								:img="`${$imageUrl}/edit.svg`"
								text="Editar"
								@click-icon="editSubsidiary(props.row)"
							/>
							<app-tooltip-button
								:img="`${$imageUrl}/delete-button.svg`"
								text="Eliminar"
								color="info"
								@click-icon="deleteSubsidiary(props.row)"
							/>
						</td>
					</template>
				</app-table>
			</p-card>
		</div>
		<confirm-dialog ref="confirmDialog" />
	</div>
</template>

<script>
import PButton from '@/modules/shared/components/ui/p-button';
import PHorizontalDivider from '@/modules/shared/components/ui/p-horizontal-divider';
import ConfirmDialog from '@/modules/shared/components/ui/ConfirmDialog';
import PCard from '@/modules/shared/components/ui/Card/p-card';
import { required } from 'vuelidate/lib/validators';
import { pathOr } from 'ramda';
import { mapState } from 'vuex';

function created() {
	this.loadData();
}

function textButton() {
	return this.idSub ? 'Actualizar' : 'Guardar';
}

async function loadData() {
	const params = { ...this.params };
	try {
		const { data: response, headers } = await this.$httpPraktiko.get('subsidiaries', { params });
		this.rows = response;
		this.lastPage = Number(headers['x-last-page']);
		this.totalItems = Number(headers['x-quantity']);
	} catch (error) {
		this.showGenericError();
	}
}

function removeItem(item) {
	const index = this.newSubsidiary.jobsSubsidiary.indexOf(item.id);
	if (index > -1) {
		this.newSubsidiary.jobsSubsidiary.splice(index, 1);
	}
}

function changeColor(fieldName) {
	this.columns.forEach((c, index) => {
		if (c.fieldName !== fieldName && c.color) {
			this.$set(this.columns, index, { ...c, color: 'gray' });
		}
	});
}

function changeSort({ fieldName, sortDirection }) {
	this.params.sortField = fieldName;
	this.params.sortDirection = sortDirection;
	this.loadData();
}

async function saveSubsidiary() {
	const method = this.idSub ? 'patch' : 'post';
	const url = this.idSub ? `subsidiaries/${this.idSub}` : 'subsidiaries';
	const message = this.idSub ? 'editó' : 'creó';
	const body = {
		name: this.newSubsidiary.name,
		code: this.newSubsidiary.code,
		address: this.newSubsidiary.address,
		phone: this.newSubsidiary.phone,
		email: this.newSubsidiary.email,
		numEmployees: this.newSubsidiary.numEmployees,
		additionalInformation: {
			jobs: this.newSubsidiary.jobsSubsidiary.map(({ id, name }) => ({ id, name })),
		},
	};
	try {
		await this.$httpPraktiko[method](url, body);
		this.showNotification(`Se ${message} correctamente`);
		this.loadData();
		this.clearForm();
	} catch (error) {
		if (error.data.statusCode === 400) {
			if (error.data.message === 'EMAIL_SUBSIDIARY_ALREADY_EXIST') {
				this.showGenericError('Correo ya existe para esta Agencia');
			}
		} else {
			this.showGenericError();
		}
	}
}

function editSubsidiary(row) {
	this.newSubsidiary = {
		name: row.name,
		code: row.code,
		address: row.address,
		phone: row.phone,
		email: row.email,
		numEmployees: row.numEmployees,
		jobsSubsidiary: row.additionalInformation && row.additionalInformation.jobs
			? row.additionalInformation.jobs : null,
	};
	this.idSub = row.id;
}

async function deleteSubsidiary(row) {
	this.$refs.confirmDialog.showConfirm({
		onOk: async () => {
			try {
				await this.$httpPraktiko.delete(`subsidiaries/${row.id}`);
				this.showNotification('Registro eliminado correctamente.');
				this.loadData();
			} catch (error) {
				this.showGenericError();
			}
		},
		title: `¿Seguro que desea eliminar la Agencia ${row.name}  de la lista?`,
	});
}

function changePage(page) {
	this.params.page = page;
	this.currentPage = page;
	this.loadData();
}

function onSearchEvent(search) {
	this.params.search = search.trim() || null;
	this.changePage(1);
}

function validations() {
	return {
		newSubsidiary: {
			name: { required },
			code: { required },
			address: { required },
			phone: { required },
			email: { required },
			numEmployees: { required },
			jobsSubsidiary: { required },
		},
	};
}

function clearForm() {
	this.newSubsidiary = {
		name: '',
		code: '',
		address: '',
		phone: '',
		email: '',
		numEmployees: 1,
		jobsSubsidiary: [],
	};
	this.idSub = null;
}

function isFormValid() {
	return (
		this.$v.newSubsidiary.name.required &&
		this.$v.newSubsidiary.code.required &&
		this.$v.newSubsidiary.address.required &&
		this.$v.newSubsidiary.phone.required &&
		this.$v.newSubsidiary.email.required &&
		this.$v.newSubsidiary.numEmployees.required &&
		this.$v.newSubsidiary.jobsSubsidiary.required);
}

function data() {
	return {
		newSubsidiary: {
			name: '',
			code: '',
			address: '',
			phone: '',
			email: '',
			numEmployees: 1,
			jobsSubsidiary: [],
		},
		idSub: null,
		rows: [],
		params: {
			limit: 6,
			page: 1,
		},
		lastPage: 0,
		currentPage: 1,
		totalItems: 0,
		columns: [
			{
				id: 1,
				name: 'Código',
				value: 'code',
				visible: true,
				checked: true,
			},
			{
				id: 2,
				name: 'Nombre',
				value: 'name',
				visible: true,
				checked: true,
				sortCheck: true,
				fieldName: 'name',
				color: 'gray',
			},
			{
				id: 3,
				name: 'Dirección',
				value: 'address',
				visible: true,
				checked: true,
			},
			{
				id: 4,
				name: 'Correo',
				value: 'email',
				visible: true,
				checked: true,
			},
			{
				id: 5,
				name: 'Acciones',
				visible: true,
				checked: true,
			},
		],
	};
}

export default {
	name: 'subsidiaries',
	components: {
		PCard,
		PButton,
		PHorizontalDivider,
		ConfirmDialog,
	},
	created,
	data,
	methods: {
		loadData,
		removeItem,
		saveSubsidiary,
		editSubsidiary,
		deleteSubsidiary,
		clearForm,
		changePage,
		onSearchEvent,
		changeColor,
		changeSort,
	},
	computed: {
		isFormValid,
		...mapState('jobProfile', {
			jobList: pathOr([], ['jobList']),
		}),
		textButton,
	},
	validations,
	beforeMount() {
		this.$store.dispatch('jobEvaluation/loadJobEvaluationConfig');
		this.$store.dispatch('jobEvaluation/getGuidelineModelStatus');
		this.$store.dispatch('jobEvaluation/loadRoles');
		this.$store.dispatch('jobEvaluation/loadTitles');
		this.$store.dispatch('jobEvaluation/loadExperiences');
		this.$store.dispatch('jobEvaluation/loadEnglishLevels');
		this.$store.dispatch('jobEvaluation/loadVerbs');
		this.$store.dispatch('jobProfile/loadSortJobList');
	},
};
</script>

<style lang="scss" scoped>
.form-subsidiary {
	display: flex;
	flex-direction: column;
	justify-content: center;
	width: 100%;
	height: 100%;
	padding: 0 15px;
	h2 {
		font-family: font(bold);
		font-size: size(xlarge);
		// margin-bottom: 20px;
		padding: 10px 0;
	}
	form {
		width: 100%;
		.name-input {
			flex: 1 1 10%;
			font-family: font(regular);
			font-size: size(small);

			input {
				margin-bottom: 10px;
			}
		}
	}
}

</style>


// WEBPACK FOOTER //
// src/pages/configuration/subsidiaries.vue